<div
    #brandFormContainer
    [id]="id"
    class="agpr-brandInformation-content"
    [formGroup]="brandForm"
>
    <div class="agpr-brandInformation-lhp">
        <div class="agpr-brandInformation-brandName">
            <agpr-text-input
                formControlName="name"
                [id]="id + '_brandIdentityName'"
                [class]="'agpr-brandInformation-field'"
                [label]="'Common.brandInformation.name.label'"
                [placeholder]="'Common.brandIdentityCard.nameInput.placeholder' | localize"
                [maxLength]="256"
                [bottomMargin]="false"
            ></agpr-text-input>
            @if (name.hasError('emptyName')) {
                <agpr-form-message [id]="id + '_error_emptyName'" [marginBottom]="0">
                    {{ 'Common.brandIdentity.emptyName.message' | localize }}
                </agpr-form-message>
            } @else if (name.hasError('nameExists')) {
                <agpr-form-message [id]="id + '_error_nameExists'" [marginBottom]="0">
                    {{ 'Common.brandIdentity.nameExists.message' | localize }}
                </agpr-form-message>
            }
        </div>
        <agpr-text-input-chips
            formControlName="nameVariations"
            [id]="id + '_nameVariations'"
            [class]="'agpr-brandInformation-field'"
            [header]="'Common.brandInformation.nameVariations.label'"
            [tooltip]="'Common.brandInformation.nameVariations.tooltip'"
            [placeholder]="'Common.brandInformation.nameVariations.placeholder'"
            [splitOnPattern]="splitOnPattern"
            [alwaysShowChips]="true"
        ></agpr-text-input-chips>
        <agpr-brand-logo
            formControlName="logo"
            [id]="id + '_logo'"
            class="agpr-brandInformation-field"
            header="Common.brandInformation.logo.label"
        ></agpr-brand-logo>
        <agpr-brand-colors
            formControlName="colors"
            [id]="id + '_colors'"
            class="agpr-brandInformation-field"
        ></agpr-brand-colors>
        <agpr-brand-competitors
            formControlName="competitors"
            [id]="id + '_competitors'"
            class="agpr-brandInformation-field"
            [brand]="this.brand"
            (createCompetitor)="onCreateCompetitor($event)"
            (selectCompetitor)="onSelectCompetitor($event)"
        ></agpr-brand-competitors>
    </div>
    <div class="agpr-brandInformation-rhp">
        <agpr-brand-topics
            formControlName="topics"
            [id]="id + '_topics'"
            [class]="'agpr-brandInformation-field'"
        ></agpr-brand-topics>
        <agpr-textarea-input
            formControlName="bio"
            [id]="id + '_bio'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.bio.label'"
            [tooltip]="'Common.brandInformation.bio.tooltip'"
            [placeholder]="'Common.brandInformation.bio.placeholder'"
            [rows]="5"
            [bottomMargin]="false"
        ></agpr-textarea-input>
        <agpr-textarea-input
            formControlName="tagline"
            [id]="id + '_tagline'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.tagline.label'"
            [tooltip]="'Common.brandInformation.tagline.tooltip'"
            [placeholder]="'Common.brandInformation.tagline.placeholder'"
            [rows]="5"
            [bottomMargin]="false"
        ></agpr-textarea-input>
        <agpr-textarea-input
            formControlName="missionStatement"
            [id]="id + '_missionStatement'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.missionStatement.label'"
            [tooltip]="'Common.brandInformation.missionStatement.tooltip'"
            [placeholder]="'Common.brandInformation.missionStatement.placeholder'"
            [rows]="5"
            [bottomMargin]="false"
        ></agpr-textarea-input>
        <agpr-textarea-input
            formControlName="products"
            [id]="id + '_products'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.products.label'"
            [tooltip]="'Common.brandInformation.products.tooltip'"
            [placeholder]="'Common.brandInformation.products.placeholder'"
            [rows]="5"
            [bottomMargin]="false"
        ></agpr-textarea-input>
        <agpr-textarea-input
            formControlName="brandVoice"
            [id]="id + '_brandVoice'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.voice.label'"
            [tooltip]="'Common.brandInformation.voice.tooltip'"
            [placeholder]="'Common.brandInformation.voice.placeholder'"
            [rows]="3"
            [bottomMargin]="false"
        ></agpr-textarea-input>
        <agpr-textarea-input
            formControlName="keyValuePropositions"
            [id]="id + '_keyValuePropositions'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.keyValuePropositions.label'"
            [tooltip]="'Common.brandInformation.keyValuePropositions.tooltip'"
            [placeholder]="'Common.brandInformation.keyValuePropositions.placeholder'"
            [rows]="5"
            [bottomMargin]="false"
        ></agpr-textarea-input>
        <agpr-text-input
            formControlName="industry"
            [id]="id + '_industry'"
            [class]="'agpr-brandInformation-field'"
            [label]="'Common.brandInformation.industry.label'"
            [tooltip]="'Common.brandInformation.industry.tooltip'"
            [placeholder]="'Common.brandInformation.industry.placeholder'"
            [bottomMargin]="false"
        ></agpr-text-input>
        <agpr-text-input-chips
            formControlName="websites"
            [id]="id + '_websites'"
            [class]="'agpr-brandInformation-field'"
            [header]="'Common.brandInformation.websites.label'"
            [placeholder]="'Common.brandInformation.websites.placeholder'"
            [splitOnPattern]="splitOnPattern"
            [useLink]="true"
            [chipValidations]="websiteChipValidations"
            [alwaysShowChips]="true"
        ></agpr-text-input-chips>
        <agpr-brand-social-links
            formControlName="socialLinks"
            [id]="id + '_socialLinks'"
            [class]="'agpr-brandInformation-field'"
        ></agpr-brand-social-links>
        <agpr-brand-custom-information
            formControlName="customInfo"
            [id]="id + '_customInfomation'"
            [class]="'agpr-brandInformation-field'"
        ></agpr-brand-custom-information>
    </div>
</div>